import React, { useState, useContext, useEffect, useRef } from "react";
import styles from '../Dashboard.module.scss';
import { Star, X } from "react-feather";
import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import { GET_SCHOOL_REVIEWS } from "../services/graphql";
import boomer from '../../../images/loader-boomer.png'
import { STUDENT_ADD_READING_BOOK } from "../../Book/services/graphql";
import { AuthContext } from "../../../services/user/AuthProvider";
import { FormErrors } from "@squirrellearningltd/go-pupil-components";
import { navigate } from "@reach/router";
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { BOOK_TYPES } from "../../../services/constants";
import reviewBook from '../../../images/review_book.png';
import starFilled from '../../../images/new-star-filled.png';
import starEmpty from '../../../images/new-star-empty.png';

import { useTranslation } from 'react-i18next';

const stars = [1, 2, 3, 4, 5];

const limit = 5;

const getFirstName = name => name ? name.split(' ')[0] : '';

const Reviews = ({ loadMoreCount }) => {
    const { t } = useTranslation();

    const [review, setReview] = useState(null);
    const [formErrors, setFormErrors] = useState([]);

    const [showForm, setShowForm] = useState(false);

    const [reviews, setReviews] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const lastLoadMoreCount = useRef(0);

    const { currentUser: user } = useContext(AuthContext);


    const [getInitialReviews] = useLazyQuery(GET_SCHOOL_REVIEWS, {
        onCompleted: data => {
            const newReviews = data.schoolByCode.bookReviews || [];
            setReviews(newReviews);
            setHasMore(newReviews.length === limit);
        }
    })

    const [getMoreReviews, { loading: loadingMore }] = useLazyQuery(GET_SCHOOL_REVIEWS, {
        fetchPolicy: 'cache-and-network',
        onCompleted: data => {
            const moreReviews = data.schoolByCode.bookReviews || [];
            if (moreReviews.length > 0) {
                setReviews(prevReviews => prevReviews.concat(moreReviews));
            }
            setHasMore(moreReviews.length === limit);

        }
    });
    useEffect(() => {
        getInitialReviews({
            variables: {
                schoolCode: user?.school?.schoolCode,
                offset: 0,
                limit
            }
        });
    }, []);

    useEffect(() => {
        if (loadMoreCount > lastLoadMoreCount.current && !loadingMore && hasMore) {
            lastLoadMoreCount.current = loadMoreCount;
            getMoreReviews({
                variables: {
                    schoolCode: user?.school?.schoolCode,
                    offset: reviews.length,
                    limit
                }
            })
        }
    }, [getMoreReviews, hasMore, loadMoreCount, loadingMore, reviews.length, user])


    const [studentAddReadingBook, { loading }] = useMutation(STUDENT_ADD_READING_BOOK, {
        onCompleted: ({ studentAddReadingBook }) => {
            if (studentAddReadingBook.errors && studentAddReadingBook.errors.length !== 0) {
                setFormErrors(studentAddReadingBook.errors);
                return;
            }
            else if (studentAddReadingBook?.studentReadingBook?.id) {
                setShowForm(false);
                setReview(null);
                navigate(`/book/${studentAddReadingBook.studentReadingBook.id}`);
            }
        },
    });

    const { register, handleSubmit, errors } = useForm({
        validationSchema: Yup.object().shape({
            bookType: Yup.number().typeError(t('select_book_type'))
        })
    });

    const onSubmit = ({ bookType }) => {
        studentAddReadingBook({
            variables: {
                bookId: review.book.id,
                bookType
            }
        })
    }

    return (
        <div className={styles.reviewsPanel}>
            <h2 className={styles.reviewsPanelTitle}>
                <img src={reviewBook} alt="" />
                Book Reviews
            </h2>
            <div className={styles.reviewsList}>
                {reviews.length > 0 ?
                    <>
                        {reviews.map(review => (
                            <div onClick={() => setReview(review)} className={styles.reviewItem} key={review.id}>
                                <div className={styles.reviewItemBoomer}>
                                    <img src={review.author?.boomerAvatarUrl ? `${review.author.boomerAvatarUrl}?v=${review.author?.updatedAt.replace(/\s/g, '')}` : boomer} alt={getFirstName(review.author.name)} />
                                </div>
                                <div className={styles.reviewItemBody}>
                                    <div className={styles.reviewItemHead}>
                                        <h3>{getFirstName(review.author.name)}</h3>
                                        <div className={styles.reviewItemStars}>
                                            {stars.filter(star => star <= review.reviewRate).map(star => (
                                                <Star color="#FFD506" key={`star${star}`} size="18" fill="#FFD506" />
                                            ))}
                                        </div>
                                    </div>
                                    <p>{review.book.title}</p>
                                </div>
                            </div>
                        ))}

                    </> : <p>No reviews</p>
                }
            </div>
            {review &&
                <div className={styles.reviewModalOverlay}>
                    <div
                        aria-labelledby="review-modal-title"
                        aria-modal="true"
                        className={styles.reviewModalDialog}
                        role="dialog"
                    >
                        <button
                            aria-label="Close review"
                            className={styles.reviewModalClose}
                            onClick={() => setReview(null)}
                            type="button"
                        >
                            <X />
                        </button>
                        <div className={styles.reviewHeader}>
                            <h1 className="u-text-center u-m-base-2" id="review-modal-title">{review.book.title}</h1>
                            <div className={styles.reviewModalStars}>
                                {stars.map(star => (
                                    <img
                                        alt=""
                                        key={`star${star}`}
                                        src={star <= review.reviewRate ? starFilled : starEmpty}
                                    />
                                ))}
                            </div>
                        </div>
                        <p className="u-m-base-3 u-text-center">{review.author.name}</p>
                        <div className={`newlines ${styles.reviewModalText}`}>
                            {review.reviewText}
                        </div>
                        {formErrors && <FormErrors errors={formErrors} />}
                        {!showForm ? (
                            <div className="u-text-center u-m-top-2">
                                <button
                                    type="button"
                                    onClick={() => setShowForm(true)}
                                    className="btn-primary"
                                >Add book to my reading</button>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className={styles.bookResultSelectType}>
                                    <select ref={register} name="bookType" className="basic-form__text-select">
                                        {BOOK_TYPES.filter(book => book.type !== 4).map(book => (
                                            <option key={book.type} value={book.type}>{t(book.extended_label)}</option>
                                        ))}
                                    </select>
                                </div>
                                {errors.bookType && <p className="basic-form__hint">{errors.bookType.message}</p>}
                                {formErrors.length !== 0 && <FormErrors errors={formErrors.map(error => t(error))} />}
                                <button type="submit" className="btn-primary">{loading ? t('adding') : t('select_book')}</button>
                            </form>
                        )}
                    </div>
                </div>
            }
        </div >
    )
}

export default Reviews;
